module.exports = __webpack_public_path__ + "static/media/nu11.cd3ec899.webp";